export default "__VITE_ASSET__f2f54a00__"